module.exports = __webpack_public_path__ + "img/step-active.81c039de.svg";